import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=056b31b8&scoped=true&"
import script from "./transfer.vue?vue&type=script&lang=js&"
export * from "./transfer.vue?vue&type=script&lang=js&"
import style0 from "./transfer.vue?vue&type=style&index=0&id=056b31b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b31b8",
  null
  
)

export default component.exports